import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-side-navbar',
  templateUrl: './side-navbar.component.html',
  styleUrls: ['./side-navbar.component.scss','../patient-profile/patient-profile.component.scss']
})
export class SideNavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
